const _require = require('@truqc/content-path'),
  getValue = _require.getValue;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate getTransientContextBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const path = await evaluateSource(source.path, content, parentContentPath, transientContext, nativeFunctions);
  if (typeof path !== 'string') {
    return undefined;
  }
  const value = path.length ? getValue(path, transientContext) : transientContext;
  return evaluateSource(value, content, parentContentPath, transientContext, nativeFunctions);
};
module.exports = {
  evaluate
};